import { Box, Skeleton } from "@mui/material"

function SectionSkeleton() {
  return (
    <Box padding={1}>
      <Skeleton
        animation="wave"
        variant="rounded"
        sx={{
          width: "100%",
          transform: "none",
          height: { xs: "300px", md: "450px" }
        }}
      />
    </Box>
  )
}

export default SectionSkeleton